module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.MultiblTableArray.length > 0) ? _c('div', {
    staticClass: "box"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('table', {
    staticClass: "table table-bordered",
    attrs: {
      "id": "MultiBl"
    }
  }, [_vm._m(1), _vm._v(" "), _c('tbody', _vm._l((_vm.MultiblTableArray), function(item, index) {
    return _c('tr', {
      key: index
    }, [_c('td', [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', {
      staticClass: "showMoreData"
    }, [_c('span', {
      staticStyle: {
        "color": "blue",
        "font-size": "15px"
      },
      on: {
        "click": function($event) {
          _vm.viewEditBLNonUs(item, index)
        }
      }
    }, [_c('u', [_vm._v(_vm._s(item.billLading + item.billLadingSeries) + "    "), _vm._m(2, true)])]), _c('br'), _vm._v(" "), (item.createdBy) ? _c('span', [_vm._v("Created By : " + _vm._s(item.createdBy)), _c('br')]) : _vm._e(), _vm._v(" "), (item.CreatedAt) ? _c('span', [_vm._v("Created At : " + _vm._s(item.CreatedAt)), _c('br')]) : _vm._e(), _vm._v(" "), (item.UpdatedBy) ? _c('span', [_vm._v("Updated By : " + _vm._s(item.UpdatedBy)), _c('br')]) : _vm._e(), _vm._v(" "), (item.UpdatedAt) ? _c('span', [_vm._v("Updated At : " + _vm._s(item.UpdatedAt)), _c('br')]) : _vm._e()]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.typeOfBL == "1" ? "House BL" : "Linear BL"))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.blStage))]), _vm._v(" "), _c('td', [_c('span', {
      domProps: {
        "innerHTML": _vm._s(item.consignor)
      }
    }, [_vm._v(_vm._s(item.consignor))])]), _vm._v(" "), _c('td', [_c('span', {
      domProps: {
        "innerHTML": _vm._s(item.consignee)
      }
    }, [_vm._v(_vm._s(item.consignee))])]), _vm._v(" "), _c('td', [(item.fclBlId != '') ? _c('b-button', {
      staticStyle: {
        "margin-left": "5px"
      },
      attrs: {
        "size": "sm",
        "variant": "warning"
      },
      on: {
        "click": function($event) {
          _vm.Print(item.uploadBL)
        }
      }
    }, [_vm._v("B/L PDF")]) : _vm._e()], 1), _vm._v(" "), _c('td', [(item.fclBlId != '') ? _c('b-button', {
      staticStyle: {
        "margin-left": "5px"
      },
      attrs: {
        "size": "sm",
        "variant": "warning"
      },
      on: {
        "click": function($event) {
          _vm.downloadWord(item, item.fclBlId)
        }
      }
    }, [_vm._v("B/L Word")]) : _vm._e()], 1), _vm._v(" "), _c('td', [_c('div', {
      attrs: {
        "id": 'row' + item.fclBlId
      }
    }, [(_vm.$sessionsStorage.get('designation') == 'Admin' &&
      _vm.$sessionsStorage.get('nameUser') == 'Bhavneesh') ? _c('md-switch', {
      staticClass: "md-primary",
      attrs: {
        "id": 'approval' + item.fclBlId,
        "name": "approval",
        "value": item.isActiveBL == 1 ? true : false
      },
      on: {
        "change": function($event) {
          _vm.activateUser(item)
        }
      }
    }, [_c('h6', [_c('br'), _vm._v(" "), _c('b-badge', {
      attrs: {
        "variant": item.isActiveBL == 1 ? 'success' : 'danger'
      }
    }, [_vm._v(_vm._s(item.isActiveBL == 1 ? "Active" : "In-Active"))])], 1)]) : _vm._e()], 1), _vm._v(" "), (
      item.fclBlId != '' &&
      item.fclBlId != undefined &&
      item.originalDone == true
    ) ? _c('b-button', {
      attrs: {
        "size": "sm",
        "variant": "warning"
      },
      on: {
        "click": function($event) {
          _vm.EditBLRequest(item)
        }
      }
    }, [_vm._v(" Edit BL Request")]) : _vm._e()], 1)])
  }))])])]) : _vm._e(), _vm._v(" "), _c('md-dialog-confirm', {
    ref: "popMail",
    attrs: {
      "md-content-html": _vm.alert.content,
      "md-ok-text": _vm.alert.ok
    },
    on: {
      "close": _vm.sendMultiPreAlertMail
    }
  }), _vm._v(" "), _c('md-dialog-confirm', {
    ref: "popMultiMailAfter",
    attrs: {
      "md-content-html": _vm.alert.content,
      "md-ok-text": _vm.alert.ok
    }
  }), _vm._v(" "), _c('md-dialog-confirm', {
    ref: "popMultiBLMail",
    attrs: {
      "md-content-html": _vm.alert.content,
      "md-ok-text": _vm.alert.ok
    },
    on: {
      "close": _vm.sendMultiBLApprovalMail
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header"
  }, [_c('label', {
    staticClass: "box-title"
  }, [_c('u', [_vm._v("Multi BL Details")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("SN.")]), _vm._v(" "), _c('th', [_vm._v("BL No.")]), _vm._v(" "), _c('th', [_vm._v("BL Type")]), _vm._v(" "), _c('th', [_vm._v("BL Stage")]), _vm._v(" "), _c('th', [_vm._v("Consignor")]), _vm._v(" "), _c('th', [_vm._v("Consignee")]), _vm._v(" "), _c('th', [_vm._v("PDF")]), _vm._v(" "), _c('th', [_vm._v("Word")]), _vm._v(" "), _c('th', [_vm._v("Edit BL Request")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "btn btn-outline-info btn-sm",
    staticStyle: {
      "font-size": "15px"
    },
    attrs: {
      "type": "button"
    }
  }, [_c('i', {
    staticClass: "md-icon md-theme-default material-icons",
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("edit")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0f9a274e","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/component/common/multiBl.vue
// module id = 2394
// module chunks = 0